import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, Divider, Modal, Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import ConsignmentFreightTable from "./ConsignmentFreightTable";
import { isInLoggedInUsersTenancy, userCanAccessAllTenants, userHasPermission } from "../../../../swzutils/UserPermissionsUtil";
import { ConsignmentStatusEnum } from "./api/Representation";
import CreationSourceType from "../../enums/CreationSourceType";
import ConsignmentFreightItemModal from "./ConsignmentFreightItemModal";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector } from "../../../../store/slice/auth";
const ConsignmentFreightPanel = ({ consignment, canChangeSavedProduct = true, onUpdate, showTrackingCode = true, showWasteRecordId = true, showDescription = true, }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingFreightLine, setEditingFreightLine] = useState(undefined);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const confirmDeleteFreightLine = (freightItem) => {
        Modal.confirm({
            title: 'Are you sure?',
            content: 'This will remove the freight line from this delivery',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => {
                deleteFreightLine(freightItem);
            }
        });
    };
    const deleteFreightLine = (freightItem) => {
        setNetworkRequestInProgress(true);
        axios.delete(`/admin/v1/consignments/${consignment.id}/freight/${freightItem.id}`).then(( /*response*/) => {
            setNetworkRequestInProgress(false);
            onUpdate && onUpdate(freightItem);
        }).catch((error) => {
            setNetworkRequestInProgress(true);
            axiosErrorHandler(error);
        });
    };
    const addFreightLine = () => {
        setEditingFreightLine(undefined);
        setEditModalVisible(true);
    };
    const editFreightLine = (freightItem) => {
        setEditingFreightLine(freightItem);
        setEditModalVisible(true);
    };
    const closeEditModal = () => {
        setEditingFreightLine(undefined);
        setEditModalVisible(false);
    };
    const consignmentCreationSource = CreationSourceType.valueOf(consignment.creationSource ?? null);
    const isSubTruxAdmin = userCanAccessAllTenants(loggedInUser);
    let editMode = 'EDIT_NONE';
    if (isSubTruxAdmin || isInLoggedInUsersTenancy(loggedInUser, null, consignment?.tenantId)) {
        if (consignment.status === ConsignmentStatusEnum.STARTED) {
            editMode = 'EDIT_NET_WASTE';
        }
        else if (consignment.status === ConsignmentStatusEnum.COMPLETED) {
            editMode = 'EDIT_NET';
        }
        else {
            if (consignmentCreationSource?.canEditFreight) {
                editMode = consignment.salesOrder ? 'EDIT_ALL_EXCEPT_UOM' : 'EDIT_ALL';
            }
            else {
                editMode = 'EDIT_NET_DIMENSIONS_WEIGHT_WASTE';
            }
        }
    }
    const canEdit = editMode !== 'EDIT_NONE';
    const canAdd = editMode !== 'EDIT_NET' && editMode !== 'EDIT_NET_DIMENSIONS_WEIGHT_WASTE' && consignmentCreationSource?.canAddFreight && userHasPermission(loggedInUser, ['admin:consignmentFreight:create']);
    return (_jsx(Spin, { spinning: networkRequestInProgress, children: _jsxs("div", { children: [canAdd && _jsx("p", { children: _jsx(Button, { size: "small", onClick: addFreightLine, children: "Add freight" }) }), _jsx(ConsignmentFreightTable, { freight: consignment.freight, hasActions: canEdit && userHasPermission(loggedInUser, ['admin:consignmentFreight:update']), renderActions: (text, record /*, index: number*/) => (_jsxs("span", { children: [canEdit && userHasPermission(loggedInUser, ['admin:consignmentFreight:update']) &&
                                _jsx(Button, { size: "small", onClick: () => editFreightLine(record), children: "Edit" }), _jsx(Divider, { orientation: "vertical" }), canEdit && userHasPermission(loggedInUser, ['admin:consignmentFreight:delete']) && editMode !== 'EDIT_NET' &&
                                _jsx(Button, { size: "small", onClick: () => confirmDeleteFreightLine(record), children: "Remove" })] })) }), _jsx(ConsignmentFreightItemModal, { open: editModalVisible, consignment: consignment, editingFreightLine: editingFreightLine, editMode: editMode, canChangeSavedProduct: canChangeSavedProduct, showTrackingCode: showTrackingCode, showWasteRecordId: showWasteRecordId, showDescription: showDescription, onCancel: closeEditModal, onUpdate: freightItem => {
                        onUpdate && onUpdate(freightItem);
                        closeEditModal();
                    } })] }) }));
};
export default ConsignmentFreightPanel;
